import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { MarketingComponent } from './components/marketing/marketing.component';
import { MarketingContactsComponent } from './components/marketing-contacts/marketing-contacts.component';
import { MarketingNavigationComponent } from './components/marketing-navigation/marketing-navigation.component';

const routes: Routes = [
  {
    path: '', 
    component: MarketingNavigationComponent,
    children: [
      {path: 'campaigns', component: MarketingComponent },
      {path: 'contacts', component: MarketingContactsComponent },
      {path: '', redirectTo: 'campaigns', pathMatch: 'full'},
      {path: '**', redirectTo: 'campaigns', pathMatch: 'full'},
    ]
  },

  {path: '', redirectTo: '', pathMatch: 'full'},
  {path: '**', redirectTo: ''},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MarketingModuleRoutingModule {
}
